<template>
  <div class="modal fade" tabindex="-1" id="kt_modal_1">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content ticket-modal-content">
        <div class="modal-header ticket-modal-header">
          <h5 class="modal-title ticket-modal-title">
            <i class="fa fa-file-invoice"></i>
            {{ sale.status === 'PAID' ? $t('session.invoice') : $t('session.invoice_accompte') }}
            <span v-if="sale.reference" class="ticket-modal-ref">#{{ sale.reference }}</span>
          </h5>
          <div class="btn btn-icon btn-sm btn-active-light-primary" data-bs-dismiss="modal" aria-label="Close">
            <i class="fa fa-times fs-5"></i>
          </div>
        </div>

        <div class="modal-body p-0">
          <div v-show="isLoad" class="ticket-loader">
            <Loader />
          </div>

          <div v-show="!isLoad" class="ticket-layout">
            <!-- Left: Receipt preview -->
            <div class="ticket-preview-section">
              <div class="ticket-scroll">
                <div id="invoice-content">
                  <div id="invoice" class="receipt-ticket">
                    <table class="receipt-table">
                      <tbody>
                        <tr><td colspan="2" class="text-center"><strong class="company-name">{{ sale.shop_name }}</strong></td></tr>
                        <tr v-if="sale.shop_address || sale.shop_phone">
                          <td colspan="2" class="text-center header-line">
                            <template v-if="sale.shop_address">{{ sale.shop_address }}</template>
                            <template v-if="sale.shop_address && sale.shop_phone"> · </template>
                            <span v-if="sale.shop_phone" class="nowrap-unit">{{ $t('tel') }}: {{ sale.shop_phone }}</span>
                          </td>
                        </tr>
                        <tr v-if="sale.shop_ifu_number || sale.shop_rccm_number">
                          <td colspan="2" class="text-center header-line ifu-rccm-line">
                            <span v-if="sale.shop_ifu_number" class="nowrap-unit">IFU: {{ sale.shop_ifu_number }}</span>
                            <template v-if="sale.shop_ifu_number && sale.shop_rccm_number"> · </template>
                            <span v-if="sale.shop_rccm_number" class="nowrap-unit">RCCM: {{ sale.shop_rccm_number }}</span>
                          </td>
                        </tr>
                        <tr><td colspan="2" class="text-center separator">- - - - - - - - - - - - - - -</td></tr>
                        <tr><td colspan="2" class="text-center header-line">{{ sale.date }} · {{ $t('caissier') }}: {{ sale.operator }}</td></tr>
                        <tr v-if="sale.reference"><td colspan="2" class="text-center header-line">{{ $t('ticket') }}: {{ sale.reference }}</td></tr>
                      </tbody>
                    </table>

                    <table v-if="sale.customer" class="receipt-table">
                      <tbody>
                        <tr><td colspan="2" class="separator">- - - - - - - - - - - - - - -</td></tr>
                        <tr><td colspan="2"><strong>{{ $t('customer') }}:</strong> {{ sale.customer }}</td></tr>
                        <tr v-if="sale.ifu_number || sale.phone">
                          <td colspan="2" class="header-line">
                            <template v-if="sale.ifu_number">IFU: {{ sale.ifu_number }}</template>
                            <template v-if="sale.ifu_number && sale.phone"> · </template>
                            <template v-if="sale.phone">{{ $t('tel') }}: {{ sale.phone_code ? sale.phone_code + ' ' : '' }}{{ sale.phone }}</template>
                          </td>
                        </tr>
                        <tr v-if="sale.first_address_infos"><td colspan="2" class="header-line">{{ sale.first_address_infos }}</td></tr>
                        <tr v-if="sale.customer_email"><td colspan="2" class="header-line">{{ sale.customer_email }}</td></tr>
                      </tbody>
                    </table>

                    <table class="receipt-table">
                      <tbody>
                        <tr><td colspan="2" class="separator">- - - - - - - - - - - - - - -</td></tr>
                        <tr><td colspan="2"><strong>{{ $t('products') }}</strong></td></tr>
                        <tr><td colspan="2" class="separator-light"></td></tr>
                        <template v-for="product in sale.products" :key="product.name">
                          <tr class="product-row">
                            <td class="product-name-cell">
                              {{ product.name }}
                              <span v-if="product.discount != 0" class="discount-text"><br/>({{ $t('remise') }} {{ product.discount }}%)</span>
                            </td>
                            <td class="product-price-cell">{{ product.quantity }} x {{ $formatLocalAmount(product.price) }} {{ currency }}</td>
                          </tr>
                        </template>
                      </tbody>
                    </table>

                    <table class="receipt-table">
                      <tbody>
                        <tr><td colspan="2" class="separator">- - - - - - - - - - - - - - -</td></tr>
                        <tr><td>{{ $t('sub_total') }}</td><td class="text-right">{{ $formatLocalAmount(sale.sub_total) }} {{ currency }}</td></tr>
                        <tr><td>{{ $t('reduction') }}</td><td class="text-right">{{ $formatLocalAmount(sale.reduction) }} {{ currency }}</td></tr>
                        <tr class="payment-row"><td>{{ $t('session.method_cash') }}</td><td class="text-right">{{ $formatLocalAmount(sale.amountDonated) }} {{ currency }}</td></tr>
                        <tr v-if="sale.status === 'PAID'"><td>{{ $t('remise_cash') }}</td><td class="text-right">{{ $formatLocalAmount(sale.cash_change) }} {{ currency }}</td></tr>
                        <tr><td colspan="2" class="separator">= = = = = = = = = = = = = = =</td></tr>
                        <tr class="total-final-row"><td><strong>TOTAL</strong></td><td class="text-right"><strong>{{ $formatLocalAmount(sale.total) }} {{ currency }}</strong></td></tr>
                        <template v-if="sale.status === 'PARTIALLY_PAID' || sale.status === 'CREDIT'">
                          <tr><td colspan="2" class="separator">- - - - - - - - - - - - - - -</td></tr>
                          <tr><td>{{ $t('cart.acompte_total') }}</td><td class="text-right">{{ $formatLocalAmount(sale.total) }} {{ currency }}</td></tr>
                          <tr><td>{{ $t('cart.acompte_title') }}</td><td class="text-right">{{ $formatLocalAmount(sale.acompte_amount) }} {{ currency }}</td></tr>
                          <tr class="remaining-row"><td>{{ $t('cart.remaining') }}</td><td class="text-right">{{ $formatLocalAmount(sale.acompte_remaining) }} {{ currency }}</td></tr>
                        </template>
                      </tbody>
                    </table>

                    <div v-if="symefResponse && symefResponse.qrCode" class="qr-section">
                      <table class="qr-table">
                        <tbody>
                          <tr><td>{{ $t('session.code_dgi') }}</td><td>{{ symefResponse.codeMECeFDGI }}</td></tr>
                          <tr><td>{{ $t('session.code_nim') }}</td><td>{{ symefResponse.nim }}</td></tr>
                          <tr><td>{{ $t('session.code_compteur') }}</td><td>{{ symefResponse.counters }}</td></tr>
                          <tr><td>{{ $t('session.mecef_heure') }}</td><td>{{ symefResponse.dateTime }}</td></tr>
                        </tbody>
                      </table>
                      <div class="qr-code">
                        <QRCodeVue3 :width="100" :height="100" :value="symefResponse.qrCode"
                          :qrOptions="{ typeNumber: 0, mode: 'Byte', errorCorrectionLevel: 'H' }"
                          :imageOptions="{ hideBackgroundDots: true, imageSize: 0.4, margin: 0 }"
                          :dotsOptions="{ type: 'square', gradient: { type: 'linear', rotation: 0, colorStops: [{ offset: 0, color: 'black' }] } }" />
                      </div>
                    </div>

                    <div class="receipt-footer">
                      <p class="separator">- - - - - - - - - - - - - - -</p>
                      <p class="thanks-text">{{ $t('session.thanks') }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Right: Actions -->
            <div class="ticket-actions-section">
              <div class="actions-card">
                <div class="actions-icon"><i class="fa fa-receipt"></i></div>
                <h3 class="actions-title">{{ $t('session.invoice') }}</h3>
                <p class="actions-subtitle">{{ sale.reference }}</p>
                <div class="actions-buttons">
                  <button :disabled="isLoading" @click.prevent="$emit('print')" class="action-btn btn-print">
                    <i class="fa fa-print"></i><span>{{ $t('session.print') }}</span>
                  </button>
                  <button v-if="normalizationActive && (!symefResponse || !symefResponse.qrCode)" :disabled="isLoading" @click.prevent="$emit('normalize')" class="action-btn btn-normalize">
                    <i class="fa fa-stamp"></i><span>{{ $t('session.normalise') }}</span>
                  </button>
                </div>
                <div v-if="symefResponse && symefResponse.qrCode" class="success-indicator">
                  <i class="fa fa-check-circle"></i><span>Facture normalisée</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCodeVue3 from "qrcode-vue3";
import Loader from "@/components/Loader.vue";

export default {
  name: "TicketModal",
  components: { QRCodeVue3, Loader },
  props: {
    sale: { type: Object, required: true },
    currency: { type: String, default: '' },
    isLoad: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    symefResponse: { type: Object, default: null }
  },
  emits: ['print', 'normalize'],
  data() {
    return {
      // la facture normalisée n'est proposée que si la société l'a configurée
      normalizationActive: false
    }
  },
  async mounted() {
    try {
      const response = await this.$store.dispatch('posCart/checkNormalizationKey')
      this.normalizationActive = response.data?.exists === true
    } catch {
      this.normalizationActive = false
    }
  }
}
</script>

<style scoped>
.ticket-modal-content { border-radius: 12px; overflow: hidden; }
.ticket-modal-header { background: #fff; border-bottom: 1px solid #e0e0e0; padding: 14px 20px; }
.ticket-modal-title { display: flex; align-items: center; gap: 10px; font-size: 17px; font-weight: 700; color: #333; margin: 0; }
.ticket-modal-title i { color: #0b3d87; }
.ticket-modal-ref { font-size: 13px; color: #888; font-weight: 500; }
.ticket-loader { display: flex; flex-direction: column; align-items: center; justify-content: center; height: 300px; gap: 16px; color: #666; }
.ticket-layout { display: grid; grid-template-columns: 1fr 320px; height: 80vh; max-height: 80vh; background: #f8f9fa; overflow: hidden; }
.ticket-preview-section { display: flex; flex-direction: column; min-height: 0; overflow: hidden; background: #fff; border-right: 1px solid #e0e0e0; }
.ticket-scroll { flex: 1; overflow-y: auto; overflow-x: hidden; padding: 20px; background: #f0f0f0; }
.ticket-scroll::-webkit-scrollbar { width: 4px; }
.ticket-scroll::-webkit-scrollbar-thumb { background: #ccc; border-radius: 2px; }
.receipt-ticket { background: #fff; font-family: 'Courier New', Courier, monospace; font-size: 13px; color: #333; padding: 20px; border-radius: 4px; box-shadow: 0 2px 10px rgba(0,0,0,.12); max-width: 340px; margin: 0 auto; }
.receipt-table { width: 100%; border-collapse: collapse; margin-bottom: 0; }
.receipt-table td { padding: 3px 0; vertical-align: top; font-size: 13px; }
.text-center { text-align: center; }
.text-right { text-align: right; white-space: nowrap; }
.company-name { font-size: 17px; font-weight: 700; }
.separator { text-align: center; color: #aaa; padding: 4px 0 !important; }
/* le thème définit .separator comme un trait (display:block; height:0) : on le neutralise dans le ticket */
.receipt-ticket .separator { height: auto; border-bottom: 0; }
.receipt-table td.separator { display: table-cell; }
.header-line { padding: 2px 0 !important; font-size: 12px !important; }
.ifu-rccm-line { font-size: 10px !important; }
.nowrap-unit { white-space: nowrap; }
.separator-light { border-bottom: 1px solid #eee; padding: 3px 0 !important; }
.product-row td { padding: 5px 0; border-bottom: 1px solid #f0f0f0; }
.product-name-cell { width: 58%; }
.product-price-cell { width: 42%; text-align: right; white-space: nowrap; }
.discount-text { font-size: 11px; color: #0b3d87; font-style: italic; }
.payment-row td { color: #0b3d87; }
.total-final-row td { font-size: 15px; padding-top: 6px !important; }
.remaining-row td { color: #e74c3c; font-weight: 600; }
.qr-section { margin-top: 14px; padding: 10px; background: #f8f9fa; border: 2px solid #333; border-radius: 6px; }
.qr-table { margin-bottom: 10px; }
.qr-table td { font-size: 11px; padding: 2px 0; }
.qr-code { display: flex; justify-content: center; margin-top: 8px; }
.receipt-footer { text-align: center; margin-top: 14px; }
.thanks-text { font-weight: 700; text-transform: uppercase; letter-spacing: 2px; margin: 6px 0 0 0; }
.ticket-actions-section { display: flex; align-items: center; justify-content: center; padding: 24px 16px; background: #f8f9fa; }
.actions-card { background: #fff; border-radius: 14px; padding: 32px 24px; text-align: center; box-shadow: 0 4px 20px rgba(0,0,0,.08); width: 100%; }
.actions-icon { width: 70px; height: 70px; background: linear-gradient(135deg,#0b3d87,#d4a574); border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px; }
.actions-icon i { font-size: 28px; color: #fff; }
.actions-title { font-size: 17px; font-weight: 700; color: #333; margin: 0 0 6px; }
.actions-subtitle { font-size: 12px; color: #999; margin: 0 0 24px; word-break: break-all; }
.actions-buttons { display: flex; flex-direction: column; gap: 10px; }
.action-btn { display: flex; align-items: center; justify-content: center; gap: 8px; padding: 14px 20px; border: none; border-radius: 10px; font-weight: 600; font-size: 14px; cursor: pointer; transition: all .2s; width: 100%; }
.action-btn i { color: #fff; }
.action-btn:disabled { opacity: .6; cursor: not-allowed; transform: none !important; }
.btn-print { background: #0b3d87; color: #fff; }
.btn-print:hover:not(:disabled) { background: #b8894d; transform: translateY(-1px); }
.btn-normalize { background: #50cd89; color: #fff; }
.btn-normalize:hover:not(:disabled) { background: #6ad59b; transform: translateY(-1px); }
.success-indicator { display: flex; align-items: center; justify-content: center; gap: 8px; margin-top: 24px; padding-top: 20px; border-top: 1px solid #eee; color: #27ae60; font-weight: 600; font-size: 14px; }
.success-indicator i { font-size: 18px; }
/* Mobile : la facture prend toute la hauteur, les actions deviennent une barre compacte en bas */
@media (max-width: 768px) {
  .ticket-layout { grid-template-columns: 1fr; grid-template-rows: minmax(0, 1fr) auto; }
  .ticket-preview-section { border-right: none; }
  .ticket-scroll { padding: 8px; }
  .receipt-ticket { padding: 14px 10px; }
  .ticket-actions-section { border-top: 1px solid #e0e0e0; padding: 10px 12px; background: #fff; }
  .actions-card { padding: 0; border-radius: 0; box-shadow: none; }
  .actions-icon, .actions-title, .actions-subtitle { display: none; }
  .actions-buttons { flex-direction: row; }
  .action-btn { padding: 10px 12px; font-size: 13px; }
  .success-indicator { margin-top: 8px; padding-top: 8px; font-size: 13px; }
}
</style>
